<template>
    <router-link
        v-slot="{ navigate }"
        :to="{ name: 'MeyaChat' }"
        custom
    >
        <button
            class="button--accent"
            role="link"
            @click="navigate"
            @keypress.enter="navigate"
        >
            {{ $t('faq.contactUs') }}.
        </button>
    </router-link>
</template>

<script>
export default {
    name: 'FAQMeyaButton'
}
</script>
